if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.viewer || !this.elements.thumbnails) return;

        this.initSwiper();

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 300));

        this.elements.thumbnails.addEventListener('click', (event) => {
          const button = event.target.closest('button');
          const mediaToSwitch = button?.closest('[data-target]');
          if (!mediaToSwitch || !this.elements.thumbnails.contains(mediaToSwitch)) return;
          this.setActiveMedia(mediaToSwitch.dataset.target, false);
        });

        if (this.dataset.desktopLayout?.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic();
        }
      }

      initSwiper() {
        // Thumbnails swiper
        this.thumbsSwiper = new Swiper(this.elements.thumbnails, {
          spaceBetween: 12,
          slidesPerView: 'auto',
          freeMode: false,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
          watchOverflow: true,
          breakpoints: {
            0: {},
            750: {
              direction: 'vertical',
            },
          },
        });

        this.viewerSwiper = new Swiper(this.elements.viewer, {
          slidesPerView: 1,
          effect: 'slide',
          thumbs: {
            swiper: this.thumbsSwiper,
          },
        });

        // Emit custom event for compatibility
        this.viewerSwiper.on('slideChange', () => {
          const activeSlide = this.viewerSwiper.slides[this.viewerSwiper.activeIndex];

          this.elements.viewer.dispatchEvent(
            new CustomEvent('slideChanged', {
              detail: {
                currentElement: activeSlide,
              },
            })
          );
        });

        // Backward compatibility references
        this.elements.viewer.slider = this.viewerSwiper;
        this.elements.thumbnails.slider = this.thumbsSwiper;
      }

      onSlideChanged(event) {
        const mediaId = event.detail.currentElement.dataset.mediaId;

        const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);

        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const slides = Array.from(this.viewerSwiper.slides);

        const index = slides.findIndex((slide) => slide.dataset.mediaId === mediaId);

        if (index === -1) return;

        // Move main swiper
        this.viewerSwiper.slideTo(index);

        // Move thumbnail swiper
        this.thumbsSwiper.slideTo(index);

        const activeMedia = slides[index];

        this.preventStickyHeader();

        setTimeout(() => {
          const rect = activeMedia.getBoundingClientRect();

          // if (rect.top <= -0.5) {
          //   window.scrollTo({
          //     top: rect.top + window.scrollY,
          //     behavior: 'smooth',
          //   });
          // }
        });
        this.playActiveMedia(activeMedia);

        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail?.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!thumbnail) return;

        this.elements.thumbnails.querySelectorAll('button').forEach((btn) => btn.removeAttribute('aria-current'));

        thumbnail.querySelector('button')?.setAttribute('aria-current', true);

        const slides = Array.from(this.thumbsSwiper.slides);
        const index = slides.indexOf(thumbnail);

        if (index === -1) return;

        this.thumbsSwiper.slideTo(index);
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia?.();

        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.viewerSwiper) return;

        this.elements.viewer.setAttribute('role', 'presentation');

        this.viewerSwiper.slides.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

